__turbopack_context__.v({
  "base": "Embeddable-module__5R5Ihq__base",
  "baseinner": "Embeddable-module__5R5Ihq__baseinner",
  "content": "Embeddable-module__5R5Ihq__content",
  "contentBox": "Embeddable-module__5R5Ihq__contentBox",
  "title": "Embeddable-module__5R5Ihq__title",
});
